import { GptEventDetail } from '../gpt/GptEventDetail';
import GptEventEvidences from '../gpt/GptEventEvidences';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';

export function GptEventPage() {
  return (
    <FloatingCardsLayout listSize={700} list={<GptEventDetail />} contentSize={400} content={<GptEventEvidences />} />
  );
}
